import { getText } from "./utils";

// Import all images
import CheckMark from "../../assets/feednews/CheckMark.png";
import Clock from "../../assets/feednews/clock.png";
import Web from "../../assets/feednews/web.png";
import SavingMoney from "../../assets/feednews/savingMoney.png";
import SandeeAI from "../../assets/chat/sandee_ai.png";
import Laptop from "../../assets/chat/laptop.png";
import SAP from "../../assets/chat/sap.png";
import GetHelp from "../../assets/chat/get_help.png";
import ServiceLevelOne from "../../assets/chat/servicelevelone.png";
import SAPAriba from "../../assets/chat/SAP-Ariba-logo-vierkant.png";
import LogoITOne from "../../assets/feednews/logo_itone.png";
import GuideBook from "../../assets/feednews/guide_book.png";
import SCGLogo from "../../assets/feednews/scg_logo.png";
import SandeeGood from "../../assets/chat/sandee_good.png";
import LockB from "../../assets/signon/lock_b.png";
import LockW from "../../assets/signon/lock_w.png";
import MFA from "../../assets/signon/mfa.png";

export const pageConfig = () => {
  const getHowGoodChatWithSandee = () => {
    const data = getText("how_good.content");
    const array = [
      {
        text: data[0],
        imgSrc: CheckMark, // ไฟล์รูปภาพแรก
      },
      {
        text: data[1],
        imgSrc: Clock, // ไฟล์รูปภาพที่สอง
      },
      {
        text: data[2],
        imgSrc: Web, // ไฟล์รูปภาพที่สาม
      },
      {
        text: data[3],
        imgSrc: SavingMoney, // ไฟล์รูปภาพที่สี่
      },
    ];
    return array;
  };

  const getSelectChat = () => {
    const array = [
      {
        imageSrc: SandeeAI,
        buttonText: getText("sandee_genai.buttonText"),
        buttonValue: "8",
        buttonClass: "talkwithsandeecolor",
        onClick: "menuGenAIClick",
        conditionKey: "toggleAI",
        conditionComponent: "AIChatbox",
        title: getText("sandee_genai.title"),
        content: getText("sandee_genai.content"),
        chatColor: "sandeeAIcolor",
      },
      {
        imageSrc: Laptop,
        buttonText: getText("ad_unlock_reset.buttonText"),
        buttonValue: "1",
        buttonClass: "e-HR",
        onClick: "menuADClick",
        conditionKey: "toggleUnlockResetAD",
        conditionComponent: "UnlockResetAD",
        title: getText("ad_unlock_reset.title"),
        content: getText("ad_unlock_reset.content"),
        chatColor: "",
      },
      {
        imageSrc: SAP,
        buttonText: getText("sap_unlock_reset.buttonText"),
        buttonValue: "3",
        buttonClass: "SAP",
        onClick: "menuSAPClick",
        conditionKey: "toggleUnlockResetSAP",
        conditionComponent: "UnlockResetSAP",
        title: getText("sap_unlock_reset.title"),
        content: getText("sap_unlock_reset.content"),
        chatColor: "",
      },
      {
        imageSrc: SAP,
        buttonText: getText("sap_change_owner.buttonText"),
        buttonValue: "5",
        buttonClass: "sapChangeOwnerColor",
        onClick: "menuSAPChangeOwnerClick",
        conditionKey: "toggleSAPChangeOwner",
        conditionComponent: "SAPChangeOwnerChatbox",
        title: getText("sap_change_owner.title"),
        content: getText("sap_change_owner.content"),
        chatColor: "sapChangecolor",
      },
      {
        imageSrc: GetHelp,
        buttonText: getText("get_help.buttonText"),
        buttonValue: "4",
        buttonClass: "RaiseIncident",
        onClick: "menuGetHelpClick",
        conditionKey: "toggleGetHelp",
        conditionComponent: "GetHelpCxChatbox",
        title: getText("get_help.title"),
        content: getText("get_help.content"),
        chatColor: "raiseIncidentcolor",
      },
      {
        imageSrc: ServiceLevelOne,
        buttonText: getText("cs_unlock_reset.buttonText"),
        buttonValue: "2",
        buttonClass: "AccountITOneCS",
        onClick: "menuUnlockResetByItOneCxClick",
        conditionKey: "toggleUnlockResetByItOne",
        conditionComponent: "UnlockResetByItOneCxChatBox",
        title: getText("cs_unlock_reset.title"),
        content: getText("cs_unlock_reset.content"),
        chatColor: "accountITOneCScolor",
      },
      // {
      //   imageSrc: ServiceLevelOne,
      //   buttonText: getText("cs_unlock_reset.buttonText") + "[Old ES]",
      //   buttonValue: "2",
      //   buttonClass: "AccountITOneCS",
      //   onClick: "menuEHRClick",
      //   title: getText("cs_unlock_reset.title"),
      //   content: getText("cs_unlock_reset.content"),
      // },
      {
        imageSrc: SAPAriba,
        buttonText: getText("sap_ariba.buttonText"),
        buttonValue: "7",
        buttonClass: "scgariba",
        onClick: "menuAribaClick",
        conditionKey: "toggleAriba",
        conditionComponent: "Ariba",
        title: getText("sap_ariba.title"),
        content: getText("sap_ariba.content"),
        chatColor: "",
      },
    ];
    return array;
  };

  const getAnnouncement = () => {
    const array = [
      {
        imageSrc: LogoITOne,
        width: "30",
        title: getText("announcement1.title"),
        disscription: getText("announcement1.description"),
        href: "https://scg.service-now.com/myrequestscg",
        click: getText("announcement1.click"),
      },
      {
        imageSrc: GuideBook,
        width: "30",
        title: getText("announcement2.title"),
        disscription: getText("announcement2.description"),
        href: "https://scg.service-now.com/myrequestscg?id=u_kb_article&sys_id=92ab3ba4db241450c48ef0eb0c9619b1",
        click: getText("announcement2.click"),
      },
      {
        imageSrc: SCGLogo,
        width: "50",
        title: getText("announcement3.title"),
        disscription: getText("announcement3.description"),
        href: "https://myaccess.scg.co.th/showLogin.cc",
        click: getText("announcement3.click"),
      },
    ];
    return array;
  };

  const getSignOnChat = () => {
    const array = [
      {
        imageSrc: SandeeGood,
        hoverImageSrc: SandeeGood,
        buttonText: getText("sign_on.buttonText"),
        buttonValue: "1",
        buttonClass: "e-HR",
        onClick: "handleLogin",
      },
      {
        imageSrc: LockB,
        hoverImageSrc: LockW,
        buttonText: getText("ad_unlock_reset.buttonText"),
        buttonValue: "2",
        buttonClass: "e-HR",
        onClick: "menuADClick",
      },

      {
        imageSrc: MFA,
        hoverImageSrc: MFA,
        buttonText: getText("re_mfa.buttonText"),
        buttonValue: "3",
        buttonClass: "e-HR",
        onClick: "onClickReRegisterMFA",
      },

      {
        imageSrc: SAPAriba,
        hoverImageSrc: SAPAriba,
        buttonText: getText("sap_ariba.buttonText"),
        buttonValue: "4",
        buttonClass: "scgariba",
        onClick: "menuAribaClick",
      },
    ];
    return array;
  };

  return { getHowGoodChatWithSandee, getSelectChat, getAnnouncement, getSignOnChat };
};

export const getLoading = () => {
  const overlay = document.createElement("div");
  overlay.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    backdrop-filter: blur(3px);
    background: rgba(255, 255, 255, 0.9);
    border-radius: 12px;
    padding: 24px 30px;
    --shadow-color: 285deg 5% 52%;
    box-shadow:
      0px 0.3px 0.4px hsl(var(--shadow-color) / 0.25),
      0px 1.2px 1.5px -0.5px hsl(var(--shadow-color) / 0.35),
      0px 2.7px 3.5px -0.9px hsl(var(--shadow-color) / 0.44),
      -0.1px 6px 7.7px -1.4px hsl(var(--shadow-color) / 0.54);
  `;

  const loadingText = document.createElement("div");
  loadingText.style.cssText = `
    color: #1F2937;
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 19px;
    font-weight: 500;
  `;

  loadingText.textContent = getText("loading");

  overlay.appendChild(loadingText);
  overlay.id = "chat-loading-overlay";

  return overlay;
};
